import { Group, Stack } from "@mantine/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { AuctionCarCard, EmptyState, ListTable } from "@/components/elements";
import { paths } from "@/config/paths";

import type { AuctionCar } from "@/types/auctions";
import type { MantineStyleProps } from "@mantine/core";

export type AuctionCarsListProps = {
  cars?: AuctionCar[];
  loading?: boolean;
  getPath?: (id: string) => string;
  onPageChange?: (page: number) => void;
  onPageSizeChange?: (pageSize: number) => void;
  page?: number;
  pageSize?: number;
  totalCars?: number;
} & MantineStyleProps;

export const AuctionCarsList: FC<AuctionCarsListProps> = ({
  cars = [],
  loading = false,
  getPath,
  onPageChange,
  onPageSizeChange,
  page = 1,
  pageSize = 25,
  totalCars = 0,
  ...props
}) => {
  const { t } = useTranslation();
  const hasPageSizeChanger = !!onPageSizeChange && totalCars > 10;
  const hasPagination = !!onPageChange && totalCars > pageSize;

  return cars.length > 0 ? (
    <Stack {...props}>
      {cars.map((car) => {
        /* console.log(car); */

        return (
          <AuctionCarCard
            key={car.vin}
            car={car}
            loading={loading}
            /* to={getPath?.(car.taxonomy_id)} */
            to={paths.app.vin.car.getHref(car.vin)}
          />
        );
      })}
      {(hasPageSizeChanger || hasPagination) && (
        <Group justify="flex-end">
          {hasPageSizeChanger && (
            <ListTable.PageSizeChanger
              label={t("components.ListTable.page_size_changer_label")}
              onChange={onPageSizeChange}
              pageSize={pageSize}
            />
          )}
          {hasPagination && (
            <ListTable.Pagination
              divider={t("components.ListTable.pagination_divider")}
              page={page}
              pageSize={pageSize}
              onChange={onPageChange}
              total={totalCars}
            />
          )}
        </Group>
      )}
    </Stack>
  ) : (
    <EmptyState type="noCars" />
  );
};
